import { endOfMonth } from 'date-fns'; // TODO(date-fns)

export class FilterParameters {
    public type: string;
    public date: Date;
    public text: string;

    public constructor(input: [string, string][]) {
        for (const tuple of input) {
            if (tuple?.length === 2) {
                const key: string = tuple[0];
                const value: string = tuple[1];
                 if (value?.trim().length > 0) {
                    if (value?.length > 0) {
                        switch (key) {
                            case 'type': {
                                this.type = value;
                                break;
                            }
                            case 'date': {
                                try {
                                    // this.date = parse(value, 'yyyy-MM', startOfMonth(new Date()));
                                    this.date = new Date(`${value}-01T00:00:00`); // TODO (valutare anche Z)
                                } catch (exception) {
                                    console.warn(`Invalid date filter "${value}" will be ignored.`, exception);
                                }
                                break;
                            }
                            case 'text': {
                                this.text = value.substring(0, 255);
                                break
                            }
                        }
                    }
                 }
            }
        }
    }

    public formattedStartDate(): string {
        if (this.date) {
            return this.date.toISOString();
        }
        return undefined;
    }

    public formattedEndDate(): string {
        if (this.date) {
            return endOfMonth(this.date).toISOString();
        }
        return undefined;
    }
}